import "./footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="footer-wraper">
        <p>Copyright © {currentYear}</p>
      </div>
    </>
  );
};

export default Footer;